import service from './service'; // 初始化登录页

export function initLogin(data) {
  return service({
    url: 'v4/web/initLogin',
    method: 'post',
    data: data
  });
}